import { useState, useEffect } from "react";
import { ChevronRight } from "lucide-react";
import developerLogo from "../../../assets-user/Slowgan.png";

const TopDevelopers = ({ title = "Top Developers" }) => {
  const [loading, setLoading] = useState(true);

  const developers = [
    {
      id: 1,
      name: "Adani Realty",
      location: "Bhubaneswar",
      totalProjects: "05",
      experience: 10,
      noOfCity: 3,
      newLaunch: 2,
      readyToMove: 2,
      underConstruction: 2,
      logo: developerLogo,
    },
    {
      id: 2,
      name: "Adani Realty",
      location: "Bhubaneswar",
      totalProjects: "05",
      experience: 10,
      noOfCity: "03",
      newLaunch: 2,
      readyToMove: 2,
      underConstruction: 2,
      logo: developerLogo,
    },
    {
      id: 3,
      name: "Adani Realty",
      location: "Bhubaneswar",
      totalProjects: "05",
      experience: 10,
      noOfCity: "03",
      newLaunch: 2,
      readyToMove: 2,
      underConstruction: 2,
      logo: developerLogo,
    },
  ];

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full">
      <div className="mx-auto">
        {/* Title */}
        <div
          className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4 mb-1 sm:mb-2 md:mb-3 lg:mb-4"
          data-aos="fade-down"
        >
          {loading ? (
            <div className="h-6 sm:h-8 w-48 sm:w-64 bg-gray-300 rounded" />
          ) : (
            <h2 className="font-medium text-[#031722] tracking-[0.01em] text-xl sm:text-2xl md:text-3xl">
              {title}
            </h2>
          )}
        </div>

        {/* Cards */}
        <div
          className="flex overflow-x-auto lg:overflow-hidden gap-4 md:gap-6 lg:grid lg:grid-cols-3 xl:grid-cols-3 scroll-smooth snap-x snap-mandatory"
          data-aos="zoom-in"
        >
          {(loading ? Array(3).fill(0) : developers).map((developer, index) => (
            <div
              key={developer?.id || index}
              className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden flex-shrink-0 w-[80%] md:w-[70%] lg:w-auto snap-start"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="p-4 sm:p-5 lg:p-6">
                <div
                  className="flex items-start gap-3 sm:gap-4 mb-4 sm:mb-5"
                  data-aos="fade-right"
                >
                  <div className="flex-shrink-0 p-2 bg-[#e5e5e5] rounded-xl w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center">
                    {loading ? (
                      <div className="w-full h-full bg-gray-300 rounded-lg" />
                    ) : (
                      <img
                        src={developer.logo}
                        alt={developer.name}
                        className="w-full h-full object-contain rounded-lg"
                        data-aos="zoom-in"
                      />
                    )}
                  </div>

                  <div className="flex-1 min-w-0">
                    {loading ? (
                      <>
                        <div className="h-5 w-full max-w-[140px] bg-gray-300 rounded mb-2" />
                        <div className="h-4 w-full max-w-[100px] bg-gray-200 rounded" />
                      </>
                    ) : (
                      <>
                        <h3
                          className="font-medium text-[#031722] tracking-[0.01em] text-base sm:text-lg lg:text-xl mb-1 truncate"
                          data-aos="fade-left"
                        >
                          {developer.name}
                        </h3>
                        <p
                          className="font-normal text-[#6A6A6A] tracking-[0.01em] text-sm sm:text-base truncate"
                          data-aos="fade-left"
                        >
                          {developer.location}
                        </p>
                      </>
                    )}
                  </div>
                </div>

                {!loading && (
                  <div className="grid grid-cols-3 gap-2 sm:gap-3">
                    <div className="text-center">
                      <div className="font-medium text-[#031722] text-base sm:text-lg lg:text-xl mb-1">
                        {developer.totalProjects}
                      </div>
                      <div className="font-normal text-[#6A6A6A] text-xs sm:text-sm">
                        Total Projects
                      </div>
                    </div>
                    <div className="text-center">
                      <div className="font-medium text-[#031722] text-base sm:text-lg lg:text-xl mb-1">
                        {developer.experience}
                      </div>
                      <div className="font-normal text-[#6A6A6A] text-xs sm:text-sm">
                        Experience
                      </div>
                    </div>
                    <div className="text-center">
                      <div className="font-medium text-[#031722] text-base sm:text-lg lg:text-xl mb-1">
                        {developer.noOfCity}
                      </div>
                      <div className="font-normal text-[#6A6A6A] text-xs sm:text-sm">
                        No. of City
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Buttons */}
              {!loading && (
                <div className="border-t border-gray-200">
                  <button className="w-full flex items-center justify-between px-4 sm:px-5 lg:px-6 py-3 sm:py-3.5 border-b border-gray-200">
                    <span className="font-normal text-[#6A6A6A] text-sm sm:text-base">
                      New Launch({developer.newLaunch})
                    </span>
                    <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
                  </button>
                  <button
                    className="w-full flex items-center justify-between px-4 sm:px-5 lg:px-6 py-3 sm:py-3.5 border-b border-gray-200"
                    data-aos-delay="100"
                  >
                    <span className="font-normal text-[#6A6A6A] text-sm sm:text-base">
                      Ready to move({developer.readyToMove})
                    </span>
                    <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
                  </button>
                  <button
                    className="w-full flex items-center justify-between px-4 sm:px-5 lg:px-6 py-3 sm:py-3.5"
                    data-aos-delay="200"
                  >
                    <span className="font-normal text-[#6A6A6A] text-sm sm:text-base">
                      Under Construction({developer.underConstruction})
                    </span>
                    <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopDevelopers;
